import { ChangeTypes } from '@/hooks';
import { FilterMultiSelect, SearchField } from '@/modules/common';

import { ModelFiltersType } from '../types/filters';

export const ModelsFilters = ({
  options,
  filters,
  onFilters,
}: {
  options: Record<string, { id: string; value: string }[]>;
  filters: ModelFiltersType;
  onFilters: (inputs: Partial<ModelFiltersType>, type?: ChangeTypes) => void;
}) => {
  return (
    <div className="flex gap-4 w-full">
      <SearchField
        placeholder="Search by model name"
        defaultValue={filters.search || ''}
        className="w-full min-w-[320px] max-w-[400px]"
        onChange={(value) =>
          onFilters({ search: value || '' }, ChangeTypes.Debounce)
        }
      />

      <FilterMultiSelect
        options={options.types}
        label="Type"
        values={filters.types || []}
        onChange={(value: string[]) => onFilters({ types: value })}
      />

      <FilterMultiSelect
        options={options.genders}
        label="Gender"
        values={filters.genders || []}
        onChange={(value: string[]) => onFilters({ genders: value })}
      />

      <FilterMultiSelect
        options={options.sizes}
        label="Size"
        values={filters.sizes || []}
        onChange={(value: string[]) => onFilters({ sizes: value })}
      />
    </div>
  );
};
